import { render, staticRenderFns } from "./classement.vue?vue&type=template&id=3a264f09"
import script from "./classement.vue?vue&type=script&lang=js"
export * from "./classement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports